if (!customElements.get('product-form')) {
    customElements.define(
      'product-form',
      class ProductForm extends HTMLElement {
        constructor() {
          super();
  
          this.form = this.querySelector('form');
          this.form.querySelector('[name=id]').disabled = false;
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
          this.cartNotification = document.querySelector('cart-notification');
        }
  
        forceOpenSiteCart() {
          const siteCart = document.querySelector('#CartDrawer.drawer');
          const btn = document.querySelector(
            '#cart-icon-bubble.header__icon--cart'
          );
  
          if (!siteCart.classList.contains('drawer-fetch') && btn) {
            btn.click();
          }
        }
  
        onSubmitHandler(evt) {
          evt.preventDefault();
  
          const submitButton = this.querySelector('[type="submit"]');
          if (submitButton.classList.contains('loading')) return; 
  
          this.handleErrorMessage();
          this.cartNotification.setActiveElement(document.activeElement);
  
          submitButton.setAttribute('aria-disabled', true);
          submitButton.classList.add('loading');
          this.querySelector('.loading-overlay__spinner')?.classList?.remove(
            'hidden'
          );
  
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
  
          const inputQty = document.querySelector('.quantity .quantity__input');
  
          const formData = new FormData(this.form);
          // formData.append(
          //   'sections',
          //   this.cartNotification
          //     .getSectionsToRender()
          //     .map((section) => section.id)
          // );
          // formData.append('sections_url', window.location.pathname);
          // if (inputQty) formData.append('quantity', inputQty.value);
  
          // config.body = formData;
  
          const itemId = formData.get('id')
          console.log(itemId)
  
          window.sideCart.addProductOpen(itemId, inputQty.value, (response) => {
            if (response?.status) {
              this.handleErrorMessage(response.description);
            } else {
              submitButton.classList.remove('loading');
              submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading-overlay__spinner').classList.add(
                'hidden'
              );
            }
          })
  
          // fetch(`${routes.cart_add_url}`, config)
          //   .then((response) => response.json())
          //   .then((response) => {
          //     if (response?.status) {
          //       this.handleErrorMessage(response.description);
          //       return;
          //     }
          //     this.forceOpenSiteCart();
          //   })
          //   .catch((e) => {
          //     console.error(e);
          //   })
          //   .finally(() => {
          //     submitButton.classList.remove('loading');
          //     submitButton.removeAttribute('aria-disabled');
          //     this.querySelector('.loading-overlay__spinner').classList.add(
          //       'hidden'
          //     );
          //     cartBindCustomEvents();
          //     bogoUpdateBind();
          //     freeGiftPick();
          //   });
        }
  
        handleErrorMessage(errorMessage = false) {
          this.errorMessageWrapper =
            this.errorMessageWrapper ||
            this.querySelector('.product-form__error-message-wrapper');
          this.errorMessage =
            this.errorMessage ||
            this.errorMessageWrapper.querySelector(
              '.product-form__error-message'
            );
  
          this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
  
          if (errorMessage) {
            this.errorMessage.textContent = errorMessage;
          }
        }
      }
    );
  }
  
  $('body').on('change', '.quantity__input', function () {
    let n = $('.quantity__input').val();
    let price = $('span#mainprice').text().replace('$', '').replace('USD', '');
    if ($('input#chk_up1').is(':checked')) {
      var oprice = $('body').find('span.oprice').text().replace('$', '');
      oprice = parseFloat(oprice);
      price = (price * n + oprice).toFixed(2);
    } else {
      price = (price * n).toFixed(2);
    }
  
    $('span.totalamount').html('$' + price);

    try {
      document.querySelector('bundle-pdp')?.clearBundleSelection?.()
    } catch {}
  });
  /* Bundle code to open side cart */
  $(document).on('Bundle.afterAddToCart', function () {
    $('.header  .header__icon--cart ').trigger('click');
  });
  /* Bundle code to open side cart */
  